import { CurrencyText, TranslatedText } from "@/components/common/text";

export const MyOfferText = ({ offer }) => {
    const isQuote = offer.type === "quote";
    const isBooking = offer.type === "booking";

    // Determine status category
    const isPending = ["PENDING", "NOT_SUBMITTED"].includes(offer.status);
    const isAccepted = offer.status === "ACCEPTED";
    const isDeclined = offer.status === "DECLINED";
    const isCanceled = ["CANCELLED"].includes(offer.status);
    const isExpired = ["EXPIRED"].includes(offer.status);
    const isCountered = offer.status === "COUNTERED";
    const isCounterAccepted = offer.status === "COUNTER_ACCEPTED";
    const isCounterRejected = offer.status === "COUNTER_REJECTED";
    const isUnknown = offer.status === "UNKNOWN";

    // Get the load's offer rate and bid amount
    const loadOfferRate = offer.loadBoardItem?.offerRate;
    const offerRate = offer.offerRate;

    // Generate message based on type and status
    if (isQuote) {
        if (isPending) {
            return (
                <div className="inline-flex gap-1 text-cm-p-text-primary text-sm/[22px]">
                    <TranslatedText>Your</TranslatedText>
                    {loadOfferRate !== offerRate ? (
                        <CurrencyText
                            num={loadOfferRate}
                            round
                            className="font-medium text-cm-p-text-secondary text-sm/[22px] line-through"
                        />
                    ) : null}
                    <CurrencyText num={offerRate} round className="font-medium text-cm-p-text-primary text-sm/[22px]" />
                    <TranslatedText>offer is being processed.</TranslatedText>
                </div>
            );
        } else if (isAccepted) {
            return (
                <div className="inline-flex gap-1 text-cm-p-text-primary text-sm/[22px]">
                    <TranslatedText>Your</TranslatedText>
                    {loadOfferRate !== offerRate ? (
                        <CurrencyText
                            num={loadOfferRate}
                            round
                            className="font-medium text-cm-p-text-secondary text-sm/[22px] line-through"
                        />
                    ) : null}
                    <CurrencyText num={offerRate} round className="font-medium text-cm-p-text-primary text-sm/[22px]" />
                    <TranslatedText>offer has being accepted.</TranslatedText>
                </div>
            );
        } else if (isDeclined) {
            return (
                <div className="inline-flex gap-1 text-cm-p-text-primary text-sm/[22px]">
                    <TranslatedText>Your</TranslatedText>
                    {loadOfferRate !== offerRate ? (
                        <CurrencyText
                            num={loadOfferRate}
                            round
                            className="font-medium text-cm-p-text-secondary text-sm/[22px] line-through"
                        />
                    ) : null}
                    <CurrencyText num={offerRate} round className="font-medium text-cm-p-text-primary text-sm/[22px]" />
                    <TranslatedText>bid is declined.</TranslatedText>
                </div>
            );
        } else if (isExpired) {
            return (
                <div className="inline-flex gap-1 text-cm-p-text-primary text-sm/[22px]">
                    <TranslatedText>Your</TranslatedText>
                    {loadOfferRate !== offerRate ? (
                        <CurrencyText
                            num={loadOfferRate}
                            round
                            className="font-medium text-cm-p-text-secondary text-sm/[22px] line-through"
                        />
                    ) : null}
                    <CurrencyText num={offerRate} round className="font-medium text-cm-p-text-primary text-sm/[22px]" />
                    <TranslatedText>bid is expired.</TranslatedText>
                </div>
            );
        } else if (isCanceled) {
            return (
                <div className="inline-flex gap-1 text-cm-p-text-primary text-sm/[22px]">
                    <TranslatedText>You have canceled the bid for</TranslatedText>
                    {loadOfferRate !== offerRate ? (
                        <CurrencyText
                            num={loadOfferRate}
                            round
                            className="font-medium text-cm-p-text-secondary text-sm/[22px] line-through"
                        />
                    ) : null}
                    <CurrencyText num={offerRate} round className="font-medium text-cm-p-text-primary text-sm/[22px]" />.
                </div>
            );
        } else if (isCountered) {
            return (
                <div className="inline-flex gap-1 text-cm-p-text-primary text-sm/[22px]">
                    <TranslatedText>Your</TranslatedText>
                    {loadOfferRate !== offerRate ? (
                        <CurrencyText
                            num={loadOfferRate}
                            round
                            className="font-medium text-cm-p-text-secondary text-sm/[22px] line-through"
                        />
                    ) : null}
                    <CurrencyText num={offerRate} round className="font-medium text-cm-p-text-primary text-sm/[22px]" />
                    <TranslatedText>bid has been countered to</TranslatedText>
                    <CurrencyText num={offer.counterRate} round className="font-medium text-cm-p-text-primary text-sm/[22px]" />.
                </div>
            );
        } else if (isCounterAccepted) {
            return (
                <div className="inline-flex gap-1 text-cm-p-text-primary text-sm/[22px]">
                    <TranslatedText>You accepted the counter bid of</TranslatedText>
                    <CurrencyText num={offer.counterRate} round className="font-medium text-cm-p-text-primary text-sm/[22px]" />.
                </div>
            );
        } else if (isCounterRejected) {
            return (
                <div className="inline-flex gap-1 text-cm-p-text-primary text-sm/[22px]">
                    <TranslatedText>You declined the counter bid of</TranslatedText>
                    <CurrencyText num={offer.counterRate} round className="font-medium text-cm-p-text-primary text-sm/[22px]" />.
                </div>
            );
        }
    }

    if (isBooking) {
        if (isPending) {
            return (
                <div className="inline-flex gap-1 text-cm-p-text-primary text-sm/[22px]">
                    <TranslatedText>Your</TranslatedText>
                    <CurrencyText num={offerRate} round className="font-medium text-cm-p-text-primary text-sm/[22px]" />
                    <TranslatedText>booking is being processed.</TranslatedText>
                </div>
            );
        } else if (isAccepted) {
            return (
                <div className="inline-flex gap-1 text-cm-p-text-primary text-sm/[22px]">
                    <TranslatedText>You have booked this load for</TranslatedText>
                    <CurrencyText num={offerRate} round className="font-medium text-cm-p-text-primary text-sm/[22px]" />
                </div>
            );
        } else if (isDeclined) {
            return (
                <div className="inline-flex gap-1 text-cm-p-text-primary text-sm/[22px]">
                    <TranslatedText>Your booking for</TranslatedText>
                    <CurrencyText num={offerRate} round className="font-medium text-cm-p-text-primary text-sm/[22px]" />
                    <TranslatedText>was declined by the broker.</TranslatedText>
                </div>
            );
        } else if (isExpired) {
            return (
                <div className="inline-flex gap-1 text-cm-p-text-primary text-sm/[22px]">
                    <TranslatedText>Your</TranslatedText>
                    <CurrencyText num={offerRate} round className="font-medium text-cm-p-text-primary text-sm/[22px]" />
                    <TranslatedText>booking is expired.</TranslatedText>
                </div>
            );
        } else if (isCanceled) {
            return (
                <div className="inline-flex gap-1 text-cm-p-text-primary text-sm/[22px]">
                    <TranslatedText>You have canceled booking for </TranslatedText>
                    {loadOfferRate !== offerRate ? (
                        <CurrencyText
                            num={loadOfferRate}
                            round
                            className="font-medium text-cm-p-text-secondary text-sm/[22px] line-through"
                        />
                    ) : null}
                    <CurrencyText num={offerRate} round className="font-medium text-cm-p-text-primary text-sm/[22px]" />.
                </div>
            );
        }
    }

    // The load closed without the broker telling us the outcome (e.g. Echo reports a covered load, not who won it).
    if (isUnknown) {
        return (
            <div className="inline-flex gap-1 text-cm-p-text-primary text-sm/[22px]">
                <TranslatedText>Your</TranslatedText>
                <CurrencyText num={offerRate} round className="font-medium text-cm-p-text-primary text-sm/[22px]" />
                <TranslatedText>{isQuote ? "bid" : "booking"} is closed. The broker doesn't share whether it was accepted.</TranslatedText>
            </div>
        );
    }

    // Fallback
    return (
        <div className="inline-flex gap-1 text-cm-p-text-primary text-sm/[22px]">
            <TranslatedText>Status unknown</TranslatedText>
        </div>
    );
};
